import en from "./en.js";
import ru from "./ru.js";
import ro from "./ro.js";
import de from "./de.js";

let lang = localStorage.getItem("language")
  ? localStorage.getItem("language")
  : "en";

export const locale = {
  locale: lang,
  fallback: "en",
  globalInjection: true,
  messages: { en, ru, ro, de },
};
